import useCheckbox from "../hooks/use-checkbox";
import { useFormContext } from "../contexts/form-context";
import { useLayoutEffect, useEffect } from "react";
import { InputDropdown } from "../../../components";
import Checkbox from "../../../components/inputs/checkbox/checkbox";
import { useTranslate } from "../../translation/hooks/use-translation";

const FormFilter = (props) => {
  const { ref, bind } = useCheckbox(props);
  const { register, deregister, updateValidity } = useFormContext();
  const { getTranslatedProps } = useTranslate();

  const {
    translatedLabel,
    translatedPlaceholder,
    translatedOptions = [],
  } = getTranslatedProps(props);

  useLayoutEffect(() => {
    if (!props.ignore) {
      const id = props.id || props.name;
      register(id, ref);
      return () => deregister(id);
    }
  }, []);

  useEffect(() => {
    updateValidity(props.name, bind.error);
  }, [bind.error]);

  return (
    <InputDropdown
      {...props}
      selected={bind.values.length}
      label={translatedLabel}
      placeholder={translatedPlaceholder}
    >
      <div style={{ minWidth: "100%" }}>
        {translatedOptions.map((option) => (
          <Checkbox
            {...bind}
            key={`${props.name}.${option.value}`}
            name={option.value}
            value={option.value}
            label={option.label}
            checked={bind.values.includes(option.value)}
            options={translatedOptions}
          />
        ))}
      </div>
    </InputDropdown>
  );
};

export default FormFilter;
